import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { GeneralrevService } from 'src/app/services/generalrev.service';
import { GeneralReviews } from 'src/app/interfaces/general-reviews';
import { NgForm } from '@angular/forms';
import { empty } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-general-reviews',
  templateUrl: './general-reviews.component.html',
  styleUrls: ['./general-reviews.component.scss']
})
export class GeneralReviewsComponent implements OnInit {

  @ViewChild('photoUrl') reviewImage:ElementRef

  review: GeneralReviews[] = []

  length: number = null

  rating:number = null;

  one = 1;

  two = 2;

  three = 3;

  four = 4;

  five = 5;

  userEmail: string = ''
  
  constructor(private generalReview: GeneralrevService,private auth:AuthService, public translate: TranslateService) { }

  ngOnInit(): void {
    
    this.generalReview.getReview().subscribe(data => {
      this.length = data.length;
      this.review = data;      
    })
    
    if(this.length !=0) {
      document.getElementById('null-comments').style.display='none';
      document.getElementById('be-first').style.display='none';
    }
    
    this.userEmail = this.auth.userEmail;

    this.translate.onLangChange.subscribe( ()=> {
      if(this.translate.currentLang == "en") {
        document.getElementById("wont_published").classList.remove("right")
        document.getElementById("rating").classList.remove("float-right")
        document.getElementById("null-comments").classList.remove("right")
      }
      else if(this.translate.currentLang == "ar") {
        document.getElementById("wont_published").classList.add("right") 
        document.getElementById("rating").classList.add("float-right")
        document.getElementById("null-comments").classList.add("right")
      }
    })
}

  onItemChange(value:number){
    this.rating = +value;
}

submit:boolean = true
  addReview(f:NgForm) {
    this.submit = false
     let name= (<GeneralReviews>f.value).name,
         message= (<GeneralReviews>f.value).message,
         photoUrl = (<HTMLInputElement>this.reviewImage.nativeElement).files[0];
        
        if((<HTMLInputElement>this.reviewImage.nativeElement).files[0] === undefined){
          this.generalReview.addReview(name,message,this.rating,this.userEmail)
          .then(()=>{
              document.getElementById('done').style.display="block";
              setTimeout(()=>{
                document.getElementById('done').style.display="none";
              },3000)
          })
        }
        else {
          this.generalReview.addReviewWithPic(name,message,this.rating,this.userEmail,photoUrl)
          .then(()=>{
            document.getElementById('done').style.display="block";
            setTimeout(()=>{
              document.getElementById('done').style.display="none";
              this.submit = true
            },4000)
          })
        }

      }
}
